import Cookies from 'js-cookie';
import { logInternalError } from './errors';
import { PARTNER_COOKIE_NAME, removePartnerCookie } from './util/partnerCookie';

/** Also read verbatim by the OneTrust bootstrap in public/index.html — rename in both places. */
const SESSION_KEY = 'fi_in_app';

/** What the iOS and Android apps write to the partner cookie in their webviews. Partner links write JSON. */
const APP_PARTNER_COOKIE_VALUE = '1';

/** Checks URL for `utm_source=fi_app` and persists to sessionStorage for the webview session. */
export function initInAppShop() {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('utm_source') !== 'fi_app') {
      return;
    }
    sessionStorage.setItem(SESSION_KEY, 'true');
    dropAppPartnerCookie();
  } catch (err) {
    logInternalError(err, { tags: { context: 'initInAppShop' } });
  }
}

export function isInAppShop(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  try {
    return sessionStorage.getItem(SESSION_KEY) === 'true';
  } catch (err) {
    logInternalError(err, { tags: { context: 'isInAppShop' } });
    return false;
  }
}

/**
 * Both apps set `fi_partner=1` before loading a webview, a marker from 2020 meant to keep ad banners
 * off the shop. `@barkinglabs/promotions-react` returns an empty promotion whenever that cookie is
 * present, which also hides the live promotion the in-app auto-apply needs. Drop the app's marker
 * only: a partner link writes a JSON value, and that offer must survive. Runs from the
 * `DocumentLandingEffects` mount effect, ahead of the banner that reads the promotion: legacy's
 * `FeaturesReady` holds the banner back until `loadFeatures()` — called in that same effect —
 * resolves, and main mounts the effect before the app bar, so it runs before the banner's.
 */
function dropAppPartnerCookie() {
  if (Cookies.get(PARTNER_COOKIE_NAME) !== APP_PARTNER_COOKIE_VALUE) {
    return;
  }
  // the apps write it against the shared parent domain; the host-only removal covers dev and tests
  removePartnerCookie(PARTNER_COOKIE_NAME);
  Cookies.remove(PARTNER_COOKIE_NAME);
}
